'use client'
import React from "react";
import Header from "@/components/header/header";
import Footer from "@/components/footer";
import { usePathname } from "next/navigation";
function AppLayout(
    {children}: React.PropsWithChildren<{}>
) {
    const pathname = usePathname();

    return <>
        {pathname==='/customer-service' ? null : <Header/>}
        <main>{children}</main>
        {pathname==='/customer-service' ? null : <Footer/>}
    </>;
}

export default AppLayout;
